import Breadcrumb from "../../shared/CustomBreadcrumb"
import OverviewFilters from "../../components/Overview/Filters"

const Overview = () => {
    return (
        <>
            <Breadcrumb crumbs={['Manage MOT', 'Overview']} />
            <OverviewFilters />
        </>
    )
}

export default Overview
